import { types } from './actions';

const initialState = {
  isOpen: false,
  formData: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case types.OPEN_DRAWER:
      return {
        ...state,
        isOpen: true,
        formData: payload,
      };
    case types.CLOSE_DRAWER:
      return {
        ...state,
        isOpen: false,
        formData: null,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.common.drawers.createNestDrawer;

export const isOpen = (state) => getScope(state).isOpen;

export const getFormData = (state) => getScope(state).formData;
